export const getSearchQuery = (state) => state.listings.query;
export const getDefaultQuery = () => ({
  text: '',
  category: '',
  offset: 100000000,
  limit: 32,
});
